module.exports = __webpack_public_path__ + "static/media/banner04.d20acd6a.qlv";